export enum PlaceTypeEnum {
  FREE = 'FREE',
  PARTNER = 'PARTNER',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  PRE_REGISTRED = 'PRE_REGISTRED',
}
